import { useQuery } from "@tanstack/react-query";
import { getDataReadinessUrl } from "api";
import { QUERY_KEYS } from "consts";

export const useGetDataReadinessUrl = () =>
  useQuery<{ embedUrl: string }>([QUERY_KEYS.DATA_READINESS_URL], getDataReadinessUrl);
